import { useTranslation } from "react-i18next";
import RegistrationHeader from "@/components/auth/registration/Header.tsx";
import { cn } from "@edusogno/lib/utils";
import DatePicker from "@edusogno/inputs/date-picker";
import dayjs from "dayjs";
import RegistrationContent from "@/components/auth/registration/Content.tsx";
import RegistrationContainer from "@/components/auth/registration/Container.tsx";
import LoadingButton from "@edusogno/primitives/loading-button";
import useFormStep from "@/utils/hooks/useFormStep.ts";
import AuthPageFooter from "@edusogno/layouts/auth-page-footer.js";

interface LanguageProps {
  className?: string;
  onNext: () => void;
}

const RegistrationDateOfBirth = ({ className, onNext }: LanguageProps) => {
  const { invalid, defaultValue, handleChange } = useFormStep("birth_date");
  const { t, i18n } = useTranslation();

  return (
    <>
      <RegistrationContainer className={cn("h-full", className)}>
        <RegistrationHeader
          title={t("auth.registration.dob_title")}
          subtitle={t("auth.registration.dob_subtitle")}
          logo={"dob"}
        />
        <RegistrationContent>
          <DatePicker
            // size="lg"
            minYear={"1950"}
            color={"grey"}
            error={invalid}
            label={t("auth.labels.dob")}
            value={dayjs(defaultValue)}
            // @ts-expect-error - lang expects "en" or "it" but resolvedLanguage is of type string
            lang={(i18n.resolvedLanguage as const) || "en"}
            maxYear={(dayjs().year() - 9).toString()}
            onValueChange={(value) => {
              const selectedValue = dayjs(value).format("YYYY-MM-DD");
              handleChange(selectedValue);
            }}
          />
          {/*{errors.data_di_nascita && (*/}
          {/*  <p className="mt-2 text-sm text-red-600">*/}
          {/*    {errors.data_di_nascita.message}*/}
          {/*  </p>*/}
          {/*)}*/}
        </RegistrationContent>
      </RegistrationContainer>
      <AuthPageFooter>
        <LoadingButton
          size={"lg"}
          type="button"
          className="hidden w-full text-lg tracking-wide md:block"
          disabled={invalid}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
        <LoadingButton
          size={"md"}
          type="button"
          className="block w-full text-lg tracking-wide md:hidden"
          disabled={invalid}
          onClick={() => onNext()}
        >
          {t("btns.next")}
        </LoadingButton>
      </AuthPageFooter>
    </>
  );
};

export default RegistrationDateOfBirth;
